// removed by extract-text-webpack-plugin
module.exports = {"Team":"Team__Team__1Hf75","TeamMembers":"Team__TeamMembers__2Zf6X","Title":"Team__Title__25LIt"};


//////////////////
// WEBPACK FOOTER
// ./client/src/containers/Home/Team/Team.css
// module id = 418
// module chunks = 0